<template>
  <footer class="footer" v-if="!isBuilding && !isInvestment && !isFavourite">
    <p class="footer__text">
      Powered by
    </p>
    <div class="footer__image">
      <!-- <span class="footer__decoration--left"></span> -->
      <a href="https://www.indigital.pl/" target="_blank" rel="nofollow">
        <img class="footer__logo" src="@/assets/logo.svg" alt=""
      /></a>
      <!-- <span class="footer__decoration--right"></span> -->
    </div>
  </footer>
</template>

<script>

export default {
  name: "foot",
  computed: {
    isCountry() {
      return this.$route.name == "country";
    },
    isInvestment() {
      return this.$route.name == "investment";
    },
    isBuilding() {
      return this.$route.name == "building";
    },
    isFloor() {
      return this.$route.name == "floor";
    },
    isFlat() {
      return this.$route.name == "flat";
    },
    isList() {
      return this.$route.name == "list" || this.$route.name == "listfloor";
    },
    isFavourite() {
      return this.$route.name == "favourites";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.footer {
  max-width: 100vw;

  position: fixed;
  z-index: 30;
  bottom: 0;
  right: 1rem;

  display: flex;

  flex-direction: column;
  justify-content: flex-end;
  align-items: center;

  @media screen and (max-width: $md) {
    display: none;
  }
  @media screen and (max-height: 750px) {
    display: none;
  }
}

.footer__text {
  display: flex;
  font-size: 12px;
  font-weight: 400;
  justify-content: center;
  align-items: flex-start;
  color: $gray;
}

.footer__image {
  position: relative;

  /* background: black; */
  padding: 10px 5rem;
  /* border-top-left-radius: 60px;
  border-top-right-radius: 60px; */
  background: url("../assets/powered_footer.svg");
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 100% ;

  a {
    display: block;
  }
}

/* .footer__decoration {
  display: block;
  background: #000;

  position: absolute;
  bottom: 0;

  height: 67%;
  width: 50px;
}

.footer__decoration--left {
  @extend .footer__decoration;
  left: -20px;

  &::before {
    content: "";
    display: block;
    background: white;

    position: absolute;
    left: -17px;
    bottom: -6px;

    height: 200%;
    width: 50px;
    clip-path: circle(100.3% at 0 0);
  }
}

.footer__decoration--right {
  @extend .footer__decoration;
  right: -20px;
  &::before {
    content: "";
    display: block;
    background: white;

    position: absolute;
    right: -17px;
    bottom: -6px;

    height: 200%;
    width: 50px;
    clip-path: circle(100.3% at 100% 0);
  }
} */

.footer__logo {
  display: block;
  object-fit: contain;
  height: $topbarHeight / 3.75;
}
</style>
